document.addEventListener('click', (e) => {
  if (e.target.closest('.product-slider-single__item--model-btn')) {
    const modelPopup = document.querySelector('.product-slider-single__item--model-popup');
    const modelPopupAttr = modelPopup.getAttribute('data-modal-id');
    const closeButton = modelPopup.querySelector('.product-slider-single__item--model-popup-button');
    const overlay = modelPopup.querySelector('.product-slider-single__item--model-popup-overlay');
    const text = modelPopup?.querySelector('.product-slider-single__item--model-popup-text');
    const modelButton = modelPopup.querySelector('model-viewer');

    modelButton.addEventListener('click', () => {
      if (text) {
        setTimeout(() => {
          text.style.opacity = 0;
        }, 500);
      }
    })

    const modelOpenerButtonAttr = e.target.getAttribute('data-modal-id');

    if (modelOpenerButtonAttr === modelPopupAttr) {
      bodyScrollLock.disableBodyScroll(modelPopup);
      modelPopup.style.display = 'block';
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        bodyScrollLock.clearAllBodyScrollLocks();
        modelPopup.style.display = 'none';
      })
    }

    if (overlay) {
      overlay.addEventListener('click', () => {
        bodyScrollLock.clearAllBodyScrollLocks();
        modelPopup.style.display = 'none';
      })
    }
  }
})
